export const REGISTER_STEPPER_NAMESPACE = 'register';

export enum REGISTER_STEPS {
  PRE_REGISTRATION = 'pre-registration',
  REGISTRATION = 'registration',
  POST_REGISTRATION = 'post-registration',
}
